import React from 'react';
import PropTypes from 'prop-types';
import {addStyle, compose} from '../../../shared';
import CustomIcon from '../custom-icon/CustomIcon';
import styles from './Button.module.scss';
import clsx from 'clsx';

export const defaultTheme = {
  outline: false,
  background: 'btn-primary',
  textColor: 'white',
  responsive: true,
  fullWidth: false
};

const createTheme = theme => {
  const classes = 'btn';
  return compose(
    addStyle(theme.outline, ' ' + "btn-outline-primary"),
    addStyle(theme.fullWidth, ' btn-full'),
    addStyle(theme.background && !theme.outline, ' ' + theme.background),
    addStyle(theme.textColor && !theme.outline, ' ' + theme.textColor),
    addStyle(theme.responsive, ' btn-responsive'),
  )(classes);
};

export const Button = props => {

  const {
    className,
    theme,
    icon,
    disabled,
    label = 'label',
    onClick,
    type = "button",
    ...other
  } = props;

  const composeTheme = createTheme(Object.assign({}, defaultTheme, theme));

  return (
    <button type={type} {...other}
            className={clsx(composeTheme, styles.button, className)}
            disabled={disabled}
            onClick={onClick}>
      <CustomIcon {...icon} />
      <span>{label}</span>
    </button>
  )
};

Button.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  theme: PropTypes.object,
  icon: PropTypes.object,
  label: PropTypes.string,
  type: PropTypes.string,
  className: PropTypes.string,
};

Button.defaultProps = {
  theme: defaultTheme,
  icon: {
    trailing: false,
  },
  disabled: false,
  label: "",
  type: "button"
};

export default React.memo(Button);

